import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { RoleGuard } from "app/guards";
import { ActividadesEconomicasProvider } from "./actividades-economicas-context";
import { ActividadesEconomicasTable } from "./actividades-economicas-table";
import { ActividadEconomicaForm } from "./actividad-economica-form";

export function ActividadesEconomicasRoutes() {
  return (
    <RoleGuard roles={["empresa:actividades-economicas"]}>
      <ActividadesEconomicasProvider>
        <Routes>
          <Route path="/" element={<Outlet />}>
            <Route index element={<ActividadesEconomicasTable />} />

            <Route path="add" element={<ActividadEconomicaForm />} />

            <Route path=":actividad_id" element={<Outlet />}>
              <Route index element={<Navigate to="edit" replace />} />

              <Route path="edit" element={<ActividadEconomicaForm />} />
            </Route>

            <Route path="*" element="ActividadesEconomicas: Page Not Found" />
          </Route>
        </Routes>
      </ActividadesEconomicasProvider>
    </RoleGuard>
  );
}
